export const customersEn: Record<string, string> = {
  'customers.title': 'Customers',
  'customers.selectCustomer': 'Select Customer',
  'customers.customer': 'Customer',
  'customers.searchPlaceholder': 'Search customers...',
  'customers.firstName': 'First Name',
  'customers.firstNamePlaceholder': 'Enter first name',
  'customers.lastName': 'Last Name',
  'customers.lastNamePlaceholder': 'Enter last name',
  'customers.email': 'Email',
  'customers.emailPlaceholder': 'Enter email address',
  'customers.phone': 'Phone',
  'customers.subtitle': 'Manage your customer database',
  'customers.table.name': 'Name',
  'customers.table.contact': 'Contact',
  'customers.table.weddingDate': 'Wedding Date',
  'customers.table.partner': 'Partner',
  'customers.table.source': 'Source',
  'customers.table.created': 'Created',
  'customers.table.lastAppointment': 'Last Appointment',
  'customers.empty.noResults': 'No customers match your filters',
  'customers.empty.noCustomers': 'No customers yet',
  'customers.empty.noCustomersDesc': 'Add your first customer to get started.',
  'customers.filters.title': 'Filters',
  'customers.filters.referral': 'Referral Source',
  'customers.filters.weddingDate': 'Wedding Date',
  'customers.filters.createdDate': 'Created Date',
  'customers.filters.from': 'From',
  'customers.filters.to': 'To',
  'customers.filters.clearAll': 'Clear all',
  'customers.filters.apply': 'Apply',
  'customers.filters.appointments': 'Appointments',
  'customers.filters.noFilter': 'No filter',
  'customers.filters.hasAnyAppointment': 'Has any appointment',
  'customers.filters.hasAppointmentType': 'Has {type} appointment',
  'customers.filters.orders': 'Orders',
  'customers.filters.hasAtLeastOneOrder': 'Has at least one order',
  'customers.filters.hasNoOrder': 'Has no order',
  'customers.filters.contact': 'Contact',
  'customers.filters.hasEmail': 'Has Email',
  'customers.filters.hasPhone': 'Has Phone',
  'customers.filters.missingContact': 'Missing Contact',
  'customers.filters.hasPortalAccount': 'Has Portal Account',
  'customers.filters.noWeddingDate': 'No Wedding Date',
  'customers.source.facebook': 'Facebook',
  'customers.source.unknown': 'Unknown',
  'customers.source.Form': 'Form',
  'customers.source.other': 'Other',
  'customers.source.walkIn': 'Walk-in',
  'customers.source.instagram': 'Instagram',
  'customers.source.website': 'Website',
  'customers.source.venue': 'Venue',
  'customers.source.friend': 'Friend',
  'customers.source.family': 'Family',
  'customers.source.manual': 'Manual',
  'customers.createTitle': 'Create New Customer',
  'customers.form.firstName': 'First Name',
  'customers.form.lastName': 'Last Name',
  'customers.form.email': 'Email',
  'customers.form.phone': 'Phone',
  'customers.form.partnerName': 'Partner Name',
  'customers.form.weddingDate': 'Wedding Date',
  'customers.form.referralSource': 'Referral Source',
  'customers.form.notes': 'Notes',
  'customers.form.selectSource': 'Select source',
  'customers.form.createButton': 'Create Customer',
  'customers.form.createdSuccess': 'Customer created successfully',
  'customers.form.createdError': 'Failed to create customer',
  'customers.sort.recentlyCreated': 'Recently Created',
  'customers.sort.oldestFirst': 'Oldest First',
  'customers.sort.nameAZ': 'Name A-Z',
  'customers.sort.nameZA': 'Name Z-A',
  'customers.sort.weddingSoonest': 'Wedding Soonest',
  'customers.sort.weddingLatest': 'Wedding Latest',
  'customers.stats.total': 'Total Customers',
  'customers.stats.upcomingWeddings': 'Upcoming Weddings',
  'customers.stats.recentlyAdded': 'Recently Added (Last 30 Days)',
  'customers.stats.missingContact': 'Missing Contact',
  'customers.stats.weddingsThisMonth': 'Weddings This Month',
  'customers.stats.noWeddingDate': 'No Wedding Date',
  'customers.stats.pastWeddingsNoOrder': 'Past Weddings (No Order)',
  'customers.stats.show': 'Show stats',
  'customers.stats.hide': 'Hide stats',
  'customers.pagination.showing': 'Showing {from}-{to} of {total} customers',
  'customers.columns.toggle': 'Columns',
  'customers.noCustomersFound': 'No customers found',

  // Legacy customer keys
  'create_new_customer': 'Create New Customer',
  'first_name_required': 'First Name*',
  'last_name_required': 'Last Name*',
  'first_name_placeholder': 'First name',
  'last_name_placeholder': 'Last name',
  'email_placeholder': 'email@example.com',
  'phone_number_placeholder': 'Phone number',
  'partner_name': 'Partner Name',
  'partner_name_placeholder': "Partner's name",
  'wedding_date': 'Wedding Date',
  'referral_source': 'Referral Source',
  'select_source': 'Select source',
  'all_referral_sources': 'All Referral Sources',
  'all_sources': 'All Sources',
  'website': 'Website',
  'instagram': 'Instagram',
  'facebook': 'Facebook',
  'friend_referral': 'Friend Referral',
  'family_referral': 'Family Referral',
  'wedding_venue': 'Wedding Venue',
  'walk_in': 'Walk-in',
  'customer_created_successfully': 'Customer created successfully',
  'failed_to_create_customer': 'Failed to create customer',

  // CustomerProfile toasts
  'customers.toast.linkCopied': 'Link copied to clipboard!',
  'customers.toast.loadError': 'Failed to load customer data',
  'customers.toast.updated': 'Customer updated successfully',
  'customers.toast.updateError': 'Failed to update customer',
  'customers.profile.notFound': 'Customer not found',
  'customers.profile.backToCustomers': 'Back to Customers',
  'customers.profile.back': 'Back',
  'customers.profile.title': 'Customer Profile',
  'customers.profile.cancel': 'Cancel',
  'customers.profile.saveChanges': 'Save Changes',
  'customers.profile.qrCode': 'QR Code',
  'customers.profile.portalQrTitle': 'Customer Portal QR Code',
  'customers.profile.weddingLabel': 'Wedding',
  'customers.profile.portalAccess': 'Customer Portal Access',
  'customers.profile.directLink': 'Direct Link',
  'customers.profile.copyLink': 'Copy Link',
  'customers.profile.print': 'Print',
  'customers.profile.download': 'Download',
  'customers.profile.qrHint': 'Have the customer scan this QR code to access their portal and complete onboarding.',
  'customers.profile.tabs.overview': 'Overview',
  'customers.profile.tabs.overviewShort': 'Info',
  'customers.profile.tabs.wedding': 'Wedding',
  'customers.profile.tabs.weddingShort': 'Wed',
  'customers.profile.tabs.leads': 'Leads',
  'customers.profile.tabs.leadsShort': 'Lead',
  'customers.profile.tabs.appointments': 'Appointments',
  'customers.profile.tabs.appointmentsShort': 'Appt',
  'customers.profile.tabs.orders': 'Orders',
  'customers.profile.tabs.ordersShort': 'Ord',
  'customers.profile.tabs.measurements': 'Measurements',
  'customers.profile.tabs.measurementsShort': 'Meas',
  'customers.profile.tabs.files': 'Files',
  'customers.profile.tabs.filesShort': 'Files',
  'customers.profile.personalDetails': 'Personal Details',
  'customers.profile.name': 'Name',
  'customers.profile.partner': 'Partner',
  'customers.profile.notesPlaceholder': 'Add notes about this customer...',
  'customers.profile.noNotes': 'No notes added yet.',
  'customers.profile.noEventDetails': 'No event details added yet.',
  'customers.profile.noDressPreferences': 'No dress preferences added yet.',
  'customers.profile.noDecisionInfo': 'No decision making info added yet.',
  'customers.profile.crossSellInterests': 'Cross-sell Interests',
  'customers.profile.interested': 'Interested',
  'customers.profile.notInterested': 'Not interested',
  'customers.profile.scheduleAppointment': 'Schedule Appointment',
  'customers.profile.noAppointments': 'No appointments scheduled yet.',
  'customers.profile.createOrder': 'Create Order',
  'customers.profile.orderNumber': 'Order #{orderNo}',
  'customers.profile.created': 'Created',
  'customers.profile.due': 'Due',
  'customers.profile.noOrders': 'No orders created yet.',
  'customers.profile.addMeasurements': 'Add Measurements',
  'customers.profile.version': 'Version {version}',
  'customers.profile.bust': 'Bust',
  'customers.profile.waist': 'Waist',
  'customers.profile.hips': 'Hips',
  'customers.profile.measuredBy': 'Measured by',
  'customers.profile.noMeasurements': 'No measurements recorded yet.',
  'customers.profile.filesDocuments': 'Files & Documents',

  // Magic link
  'customers.magicLink.trigger': 'Send Magic Link',
  'customers.magicLink.dialogTitle': 'Send Customer Portal Access',
  'customers.magicLink.dialogDescription': 'Send a secure magic link to give the customer instant access to their bridal portal.',
  'customers.magicLink.successTitle': 'Magic Link Sent!',
  'customers.magicLink.successInfo': 'The customer will receive an email with a secure link to access their portal. The link will expire in {minutes} minutes.',
  'customers.magicLink.emailLabel': 'Customer Email',
  'customers.magicLink.emailPlaceholder': 'customer@example.com',
  'customers.magicLink.expiryLabel': 'Link Expiry (minutes)',
  'customers.magicLink.sending': 'Sending...',
  'customers.magicLink.emailInvalid': 'Please enter a valid email address',
  'customers.magicLink.error.notFound': 'Customer not found. Please check the email address.',
  'customers.magicLink.error.sendFailed': 'Failed to send magic link. Please try again.',
  'customers.magicLink.error.unexpected': 'An unexpected error occurred. Please try again.',
  'customers.magicLink.sent': 'Magic Link Sent',
  'customers.magicLink.sentDescription': 'Portal access link sent to {email}',

  // Realtime appointment notifications
  'customers.realtime.newAppointment': 'New Appointment',
  'customers.realtime.newAppointmentDesc': 'A new appointment has been created',
  'customers.realtime.appointmentUpdated': 'Appointment Updated',
  'customers.realtime.appointmentUpdatedDesc': 'An appointment has been modified',
  'customers.realtime.appointmentDeleted': 'Appointment Deleted',
  'customers.realtime.appointmentDeletedDesc': 'An appointment has been removed',

  // Keyboard shortcuts
  'shortcuts.title': 'Keyboard Shortcuts',
  'shortcuts.closeModal': 'Close modal/dialog',
  'shortcuts.viewDetails': 'View appointment details',
  'shortcuts.edit': 'Edit selected appointment',
  'shortcuts.new': 'Create new appointment',
  'shortcuts.duplicate': 'Duplicate appointment',
  'shortcuts.delete': 'Delete appointment',
  'shortcuts.save': 'Save changes',
  'shortcuts.navigateForward': 'Navigate between elements',
  'shortcuts.navigateBack': 'Navigate backwards',
  'shortcuts.activate': 'Activate button/link',
  'shortcuts.category.general': 'General',
  'shortcuts.category.navigation': 'Navigation',
  'shortcuts.category.actions': 'Actions',
  'shortcuts.hint': 'Most shortcuts work when not typing in form fields. Use Tab to navigate between interactive elements and press Space or Enter to activate them.',
};
